import confetti from 'canvas-confetti'

export default (confettiType, options) => {
  const getOrigin = event => {
    const rect = event.currentTarget.getBoundingClientRect()
    const x = rect.left + rect.width / 2
    const y = rect.top + rect.height / 2
    return {
      x: x / window.innerWidth,
      y: y / window.innerHeight,
    }
  }

  const defaultConfetti = async event => {
    try {
      await confetti({
        particleCount: 350,
        ticks: 200,
        decay: 0.963,
        angle: 150,
        scalar: 1.6,
        shapes: ['square'],
        spread: 70,
        startVelocity: 24,
        ...options,
        origin: getOrigin(event),
      })
    } catch (error) {
      console.error('Confetti button error:', error)
    }
  }

  const largeConfetti = async () => {
    const scalar = 3
    const square = confetti.shapeFromPath({
      path: 'M0 0 L10 0 L10 10 L0 10 Z',
    })
    const defaults = {
      spread: 360,
      ticks: 200,
      gravity: 0.5,
      decay: 0.97,
      origin: {
        x: 0.5,
        y: 0.3,
      },
      startVelocity: 10,
      shapes: [square],
      scalar,
    }
    const shoot = () => {
      confetti({
        ...defaults,
        ...options,
        particleCount: 100,
      })
      confetti({
        ...defaults,
        ...options,
        particleCount: 20,
      })
      confetti({
        ...defaults,
        ...options,
        particleCount: 45,
        scalar: (options?.scalar ?? scalar) / 2,
        shapes: ['square'],
      })
    }
    setTimeout(shoot, 0)
    setTimeout(shoot, 100)
    setTimeout(shoot, 200)
  }

  const sideConfetti = async () => {
    const end = Date.now() + 2 * 1000

    const frame = () => {
      if (Date.now() > end) return

      confetti({
        particleCount: 2,
        angle: 60,
        shapes: ['square'],
        scalar: 2,
        spread: 100,
        startVelocity: 60,
        origin: {
          x: 0,
          y: 0.5,
        },
        ...options,
      })
      confetti({
        particleCount: 2,
        angle: 120,
        shapes: ['square'],
        scalar: 2,
        spread: 100,
        startVelocity: 60,
        origin: {
          x: 1,
          y: 0.5,
        },
        ...options,
      })

      requestAnimationFrame(frame)
    }

    frame()
  }

  switch (confettiType) {
    case 'default':
      return defaultConfetti
    case 'large':
      return largeConfetti
    case 'side':
      return sideConfetti
    default:
      return defaultConfetti
  }
}
